<script>
  import notify from "../../../../../Script/notify"
  import { sleep } from "../../../../../Script/sleep"
  import { emailRegex } from "../../../../../Script/regex"

  /**
   * @type {RegExp} - input value binded here
   */
  export let value = ""

  /**
   * @type {RegExp} - error msg for not allowed character
   */
  export let errorMsg = "Invalid email address"

  /**
   * @type {RegExp} - input name for get input value from form data
   */
  export let inputName = ""

  /**
   * @type {RegExp} - input placeholder
   */
  export let placeholder = "placeholder"

  /**
   * @type {emptyNotification}
   */
  let closeNotification = {
    close() {},
  }

  /**
   * @description function to check the input value matches the regex while on blur event
   * @param e - to capture key event
   * @function checkRegexWhileOnBlur
   */
  const checkRegexWhileOnBlur = async (e) => {
    try {
      value = value.trim()
      //not allowed charater enter to this block
      if (value && !emailRegex.test(value)) throw errorMsg
    } catch (error) {
      value = ""
      const info = "PAGE: Add Signer\nEVENT: Validating email on input blur"
      closeNotification = notify.danger(error, info)
    }
  }

  /**
   * @description function to check the input value matches the regex while on paste event
   * @param e - to capture key event
   * @function checkRegexWhileOnPaste
   */
  const checkRegexWhileOnPaste = async (e) => {
    try {
      // close previous error notification
      closeNotification.close()
      // Get the pasted text from the clipboard
      let clipboardData = e.clipboardData || window.clipboardData
      let pastedText = clipboardData.getData("text/plain")

      await sleep(500)

      //not allowed charater enter to this block
      if (pastedText && !emailRegex.test(pastedText)) {
        value = ""
        throw errorMsg
      }
    } catch (error) {
      const info = "PAGE: Add Signer\nEVENT: Validating email on input paste"
      closeNotification = notify.danger(error, info)
    }
  }
</script>

<input bind:value on:blur={checkRegexWhileOnBlur} on:paste={checkRegexWhileOnPaste} required name={inputName} id={inputName} autocomplete="off" type="text" {placeholder} class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white dark:placeholder:text-gray-200 sm:pr-9 sm:text-sm md:w-2/3" />
